import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {AuthService} from '../authentication/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(public auth: AuthService, public router: Router) {
  }

  canActivate(): boolean {

    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }
}
